import { BaseFilter } from './base-filter.interface';

export interface FiltroDeleghe extends BaseFilter {
  anno?: number | null;
  mese?: number | null;
  delegante?: string | null;
  delegato?: string | null;
}

export const filtroDelegheVuoto: FiltroDeleghe = {
  anno: null,
  mese: null,
  delegante: null,
  delegato: null,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};
